import React, { useState, useEffect } from "react";
import Landing from "./Landing";
// import PopularJobs from "./PopularJobs";

const Home = () => {
  return (
    <div className="home">
      <Landing />
      {/* <PopularJobs/> */}
    </div>
  )
}

export default Home
